import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Transformation from "../components/Transformation";
import Frequences from "../components/Frequences";
import Modules from "../components/Modules";
import Phase2 from "../components/Phase2";
import Testimonials from "../components/Testimonials";
import ProofWall from "../components/ProofWall";
import About from "../components/About";
import Pricing from "../components/Pricing";
import FaqFinal from "../components/FaqFinal";

export default function PromoPage() {
  return (
    <>
      <Navbar promo={true} />
      <Hero />
      <Transformation />
      <Frequences />
      <Modules />
      <Phase2 />
      <Testimonials />
      <ProofWall />
      <About />
      <Pricing />
      <FaqFinal />
    </>
  );
}
